/**
 * Validates a single US ZIP code (5-digit format only)
 */
export const isValidPostalCode = (code: string): boolean => {
  return /^\d{5}$/.test(code);
};

/**
 * Validates and formats a comma-separated string of ZIP codes
 * Returns an array of valid ZIP codes or null if validation fails
 */
export const validatePostalCodes = (value: string): string[] | null => {
  if (!value) return null;

  // Split by commas and trim whitespace
  const codes = value
    .split(',')
    .map((code: string) => code.trim())
    .filter((code: string) => code.length > 0);

  // Check if each code is valid
  const isValid = codes.every(isValidPostalCode);
  if (!isValid) return null;

  // Check for duplicates
  const uniqueCodes = new Set(codes);
  if (codes.length !== uniqueCodes.size) return null;

  return codes;
};

export const POSTAL_CODE_ERROR_MESSAGES = {
  INVALID_FORMAT: 'Please enter a valid 5-digit ZIP code (e.g., 12345)',
  DUPLICATES: 'Duplicate ZIP codes are not allowed',
} as const;
